import type { User } from '@/types/types'
import { can } from '@/core/permissions/can'

type PermissionRoute = {
  path: string
  permission?: string
}

const LANDING_PRIORITY: PermissionRoute[] = [
  { path: '/', permission: 'page.dashboard' },
  { path: '/tasks', permission: 'page.tasks' },
  { path: '/installations', permission: 'page.installations' },
  { path: '/installations-list', permission: 'page.installationsList' },
  { path: '/customers-link', permission: 'page.customersLink' },
  { path: '/billing', permission: 'page.billing' },
  { path: '/payments', permission: 'page.paymentsList' },
  { path: '/branches', permission: 'page.branches' },
  { path: '/users', permission: 'page.users' },
  { path: '/profile' },
]

const hasPermission = (permission?: string) => {
  if (!permission) return true
  return can(permission)
}

export const getDefaultAuthorizedRoute = (user: User | null | undefined): string => {
  if (!user) return '/auth/signin'
  const firstAllowed = LANDING_PRIORITY.find((item) => hasPermission(item.permission))
  return firstAllowed?.path || '/403'
}
